import React, { useEffect } from "react";
import { isIOS } from "react-device-detect";
import {
  APPSTORE_DOWNLOAD_LINK,
  GOOGLE_PLAY_DOWNLOAD_LINK,
} from "common/constants";
import { Redirect } from "react-router-dom";

const AppDownloadRedirect = () => {
  useEffect(() => {
    if (isIOS) {
      window.location.replace(APPSTORE_DOWNLOAD_LINK);
    } else {
      window.location.replace(GOOGLE_PLAY_DOWNLOAD_LINK);
    }
  }, []);

  return <Redirect to="/" />;
};

export default AppDownloadRedirect;
